import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from "../../../shared/services/alert/alert.service";
import { TestScheduleService } from "src/app/shared";
import Swal from "sweetalert2";
import * as moment from "moment";
import { first } from "rxjs/operators";
import { CoreService } from "../../../shared/services";


@Component({
  selector: "app-candidate-schedule",
  templateUrl: "./candidate-schedule.component.html",
  styleUrls: ["./candidate-schedule.component.scss"]
})
export class CandidateScheduleComponent implements OnInit {
  candidateId: any;
  error = "";
  today = new Date();
  sender = "candidate-schedule";
  candschedule: any = {
    can_userid: "",
    can_examid: "",
    testcenterid: "",
    teststarttime: { hour: 0, minute: 0 },
    examduration: "",
    reportingduration: "",
    testdate: "",
    test_id: ""
  };
  meridian = true;

  constructor(
    private testScheduleService: TestScheduleService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private coreService: CoreService

  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.candidateId = params.get("id");
      if (!this.isNew()) {
        this.getCandScheduleById();
      }
    });
  }
  
  isNew() {
    return this.candidateId == "new";
  }

  onTestStartTimeChange(x) {
    console.log("time ==> ", this.candschedule.teststarttime, x);
  }

  onCancel() {
    this.router.navigate(["manager/upload-test-schedule"]);
  }

  getCandScheduleById() {
    this.testScheduleService
      .getTestSchedulesById(this.candidateId)
      .pipe(first())
      .subscribe(res => {
        this.candschedule = res[0];
        if (!this.candschedule.testdate) {
          this.candschedule.testdate = moment(
            this.candschedule.testdate,
            "DD-MM-YYYY"
          ).toDate();
        }
      });
  }
 

  isNotAlphabetNotSpecialCharNotSpace(evt) {
    return this.coreService.isNotAlphabetNotSpecialCharNotSpace(evt);
  }

  isNotDotsAndNegeativeValue(evt) {
    return this.coreService.isNotDotsAndNegeativeValue(evt);
  }
  
  isNotDotAndNegeativeValue(evt) {
    return this.coreService.isNotDotAndNegeativeValue(evt);
  }

  isNumSpecialCharNotDots(evt) {
    return this.coreService.isNumSpecialCharNotDots(evt);
  }

  saveCandSchedule() {
    if (!this.candschedule.can_userid) {
      this.alertService.err(this.sender, "Candidate userid can not be blank");
      return false;
    }
    if (!this.candschedule.can_examid) {
      this.alertService.err(this.sender, "Candidate examid can not be blank");
      return false;
    }
    if (!this.candschedule.testcenterid) {
      this.alertService.err(this.sender, "Test centerid can not be blank");
      return false;
    }
    if (!this.candschedule.test_id) {
      this.alertService.err(this.sender, "Testid can not be blank");
      return false;
    }
    if (!this.candschedule.batch_id) {
      this.alertService.err(this.sender, "BatchID can not be blank");
      return false;
    }
 
  
 

    
  
    this.testScheduleService
      .saveTestSchedules(this.candschedule)
      .pipe(first())
      .subscribe(res => {
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "Candidate Schedule Data Saved");
        setTimeout(() => {
          this.router.navigate(["manager/upload-test-schedule"]);
        }, 1100);
      });
  }

  onDelete() {
    Swal.fire({
      title: "Are you sure?",
      text:
        "Candidate Schedule data will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        Swal.fire("Deleted!", "Candidate Schedule is deleted.", "success");

        this.testScheduleService
          .deleteTestSchedules(this.candidateId)
          .pipe(first())
          .subscribe(res => {
            this.router.navigate(["manager/upload-test-schedule"]);
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "Candidate Schedule is Not Deleted:)", "error");
      }
    });
  }
}
